import JSZip from 'jszip'

export default {
  methods: {
    resetSelectionPhotos () {
      this.$store.commit('image/SET_IS_SELECTING_IMAGES', false)
      this.$store.commit('image/RESET_ALL_IMAGES_CHECKED')
    },
    async downloadImagesMultiples (photos) {
      const photosUrls = this.getListOfUrls(photos)
      console.log('Downloading all pictures...', photosUrls)
      const zip = new JSZip()
      for (const photoUrl of photosUrls) {
        const response = await fetch(photoUrl)
        const blob = await response.blob()

        // Extraire le nom de l'image à partir de l'URL
        let fileName = photoUrl.substring(photoUrl.lastIndexOf('/') + 1)
        fileName = fileName.substring(fileName.indexOf('-') + 1)
        zip.file(fileName, blob)
      }

      zip.generateAsync({ type: 'blob' }).then((blob) => {
        const url = URL.createObjectURL(blob)

        // Créer un lien temporaire pour télécharger le fichier
        const a = document.createElement('a')
        a.href = url
        a.download = `photos-${this.event.name}.zip`
        document.body.appendChild(a)
        a.click()

        // Nettoyage
        URL.revokeObjectURL(url)
        document.body.removeChild(a)
      })

      // console.log('Downloading all pictures...', zip)
      // const totalImages = this.photos.length
      // this.loading = true
      //
      // for (let i = 0; i < totalImages; i++) {
      //  const url = this.photos[i]
      //  try {
      //    const response = await fetch(url)
      //    const blob = await response.blob()
      //    const link = document.createElement('a')
      //    link.href = URL.createObjectURL(blob)
      //    link.download = `image${i + 1}.jpg`
      //    link.click()
      //    this.nbDownloadedPictures = i + 1
      //    console.log(`Downloaded ${i + 1} of ${totalImages}`)
      //  } catch (error) {
      //    console.error(`Failed to download image at ${url}`, error)
      //  }
      //  await this.sleep(1000)
      // }
      // this.nbDownloadedPictures = 0
      // this.loading = false

      console.log('All images downloaded.')
    },
    getListOfUrls (images) {
      return images.map(image => {
        return `${this.$baseURI}images/${image.publicPath}`
      })
    }
  }
}
